<template>
  <div class="compete-introduce">
    <div class="title">大赛简介 <span>INTRODUCTION</span></div>
    <div class="host-unit">
      <span>主办单位：</span><div>杭州市金融工会</div>
    </div>
    <div class="host-unit">
      <span>承办单位：</span>
      <div>
        <div>杭州市金融投资集团工会</div>
        <div>恒生电子股份有限公司U+平台</div>
      </div>
    </div>
    <div class="host-unit">
      <span>协办单位：</span>
      <div>
        <div>恒生电子股份有限公司工会</div>
        <div>恒生电子股份有限公司客服总部</div>
      </div>
    </div>
    <div class="description">
      燃情夏季，挑战开启，我们将一同见证代码实力和创造力的碰撞，也期待与你一起探索前沿技术在金融科技领域的应用场景。出发吧，金融IT极客！ 
    </div>
    <img
      class="multi-logo"
      src="~@/assets/financialCompetition/logo_multi@2x.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'CompeteIntroduce',
  props: {
    isOuter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      profile: window.financialCompetitionResource.profile
    }
  }
}
</script>

<style lang="scss" scoped>
.compete-introduce {
  max-width: 1200px;
  height: 443px;
  padding: 49px 0 0 73px;
  margin: -35px auto 0;
  border-radius: 25px;
  background: url('~@/assets/financialCompetition/introduction_bg@2x.png')
    center/cover no-repeat;
  .title {
    height: 42px;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: #333;
    line-height: 42px;
    font-weight: 600;
    margin-bottom: 12px;
    span {
      font-size: 30px;
      color: #999;
    }
  }
  .host-unit {
    font-family: AlibabaPuHuiTiB;
    font-size: 18px;
    color: #303030;
    line-height: 32px;
    font-weight: 700;
    display: flex;
    div {
      font-weight: 500;
    }
  }
  .description {
    width: 560px;
    font-family: AlibabaPuHuiTiR;
    font-size: 18px;
    color: #303030;
    line-height: 24px;
    font-weight: 400;
    margin: 12px 0 22px;
  }
  .multi-logo {
    width: 419px;
    height: 29px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeIntroduce.vue